import Image from 'next/image'
import frog from '@/components/loading/frog.svg'

export function LoadingFrog() {
  return <Image fill className="object-contain" src={frog as string} alt="" />
}
